export type Experiment = {
    activateOnPageLoad: boolean;
    name: string;
    variations: {
        [key: string]: string;
    };
};

export const BuyNow: Experiment = {
    activateOnPageLoad: false,
    name: 'buy_now',
    variations: {
        Original: 'original',
        VariationB: 'variation_b',
    },
};

export const ListOverview: Experiment = {
    activateOnPageLoad: true,
    name: 'list_overview',
    variations: {
        Off: 'off',
        On: 'on',
    },
};

export const experiments: Experiment[] = [BuyNow, ListOverview];
